import { GetStaticProps } from "next";
import { getAllPosts, type PostMeta } from "~/lib/mdx";
import {
  buildDefaultSolutionsSections,
  createSolutionsPage,
} from "~/components/solutions/solutionsPageFactory";
import InfoLinks from "~/components/InfoLinks";
import { SolutionsForBuildingManagersContent as content } from "~/content/dla-administratorow-budynkow/content.pl";

const selectedId = [131, 132, 133, 134, 135];

const sections = buildDefaultSolutionsSections(content, <InfoLinks />);

export default createSolutionsPage({
  content,
  faqSelectedIds: selectedId,
  sections,
});

export const getStaticProps: GetStaticProps<{ recentPosts: PostMeta[] }> = async () => {
  const recentPosts = getAllPosts().slice(0, 3);
  return { props: { recentPosts } };
};
